export const analyticsId = {
  BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW: 'BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW',
  BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW: 'BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW',
  BROKER_HIRE_INVESTMENT_FUND_STEP_1_SUCCESS: 'BROKER_HIRE_INVESTMENT_FUND_STEP_1_SUCCESS',
  BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS: 'BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS',
  BROKER_HIRE_INVESTMENT_FUND_ERROR: 'BROKER_HIRE_INVESTMENT_FUND_ERROR',
  BROKER_HIRE_INVESTMENT_FUND_SUCCESS: 'BROKER_HIRE_INVESTMENT_FUND_SUCCESS',
  BROKER_HIRE_INVESTMENT_CONTRIBUTION_STEP_VIEW: 'BROKER_HIRE_INVESTMENT_CONTRIBUTION_STEP_VIEW',
};

const commonFields = productName => ({
  sectionFamily: 'wealth',
  sectionCategory: 'products',
  sectionName: 'funds',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'buyFunds',
  productName,
});

export const catalogue = {
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW]: ({ productName, stepNumber }) => ({
    ...commonFields(productName),
    event_name: 'step_investment_details',
    pageName: `/buyFunds/step${stepNumber}/investmentDetails`,
    processStep: 'step' + stepNumber,
    processDetail: 'investmentDetails',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW]: ({ productName, stepNumber }) => ({
    ...commonFields(productName),
    event_name: 'step_terms_conditions',
    pageName: `/buyFunds/step${stepNumber}/termsConditions`,
    processType: 'buyFunds',
    processStep: 'step' + stepNumber,
    processDetail: 'termsConditions',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_CONTRIBUTION_STEP_VIEW]: ({ productName, stepNumber }) => ({
    ...commonFields(productName),
    event_name: 'step_investment_details',
    pageName: `/buyFunds/step${stepNumber}/investmentDetails`,
    processType: 'buyFunds',
    processStep: 'step' + stepNumber,
    processDetail: 'investmentDetails',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_1_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'investmentDetails',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'termsConditions',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_ERROR]: ({ productName, errorMessage }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/buyFunds/error/genericError',
    processStep: 'error',
    processDetail: 'genericError',
    errorCategory: 'genericError',
    errorDescription: errorMessage,
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/buyFunds/success',
    processStep: 'success',
  }),
  footerButtons: ({ stepName, productName, isin, buttonNextTag }) => ({
    next: {
      data: true,
      categoriaEvento: 'buyFunds',
      accionEvento: stepName,
      etiquetaEvento: buttonNextTag,
      productName: productName,
      productID: isin,
    },
    previous: {
      data: true,
      categoriaEvento: 'buyFunds',
      accionEvento: stepName,
      etiquetaEvento: 'anterior',
      productName: productName,
      productID: isin,
    },
    cancel: {
      data: true,
      categoriaEvento: 'buyFunds',
      accionEvento: stepName,
      etiquetaEvento: 'cancelar',
      productName: productName,
      productID: isin,
    },
    finish: {
      data: true,
      categoriaEvento: 'buyFunds',
      accionEvento: stepName,
      etiquetaEvento: 'comprar',
      productName: productName,
      productID: isin,
    },
  }),
};
